import {
    GET_DOCTOR_LISTING_FAIL,
    GET_DOCTOR_LISTING_SUCCESS,
    GET_DOCTOR_DETAILS_FAIL,
    GET_DOCTOR_DETAILS_SUCCESS,
    UPDATE_DOCTOR_FAIL,
    UPDATE_DOCTOR_SUCCESS,
    DOCTOR_ACTIVATION_FAIL,
    DOCTOR_ACTIVATION_SUCCESS,
    GET_DOCTOR_HISTORY_LISTING_FAIL,
    GET_DOCTOR_HISTORY_LISTING_SUCCESS,
    EXPORT_DOCTOR_LISTING_FAIL,
    EXPORT_DOCTOR_LISTING_SUCCESS,
    GET_DOCTOR_ORDERS_FAIL,
    GET_DOCTOR_ORDERS_SUCCESS,
    GET_DOCTOR_COMMISSION_FAIL,
    GET_DOCTOR_COMMISSION_SUCCESS,
    GET_DOCTOR_COMMISSION_BREAKDOWN_FAIL,
    GET_DOCTOR_COMMISSION_BREAKDOWN_SUCCESS,
    RESET_DOCTOR_ACTION_STATE,
    RESET_DOCTOR_STATE,
    ADD_DOCTOR_SUCCESS,
    ADD_DOCTOR_FAIL,
    DELETE_DOCTOR_SUCCESS,
    DELETE_DOCTOR_FAIL,
} from "./actionTypes"

const INIT_STATE = {
    doctorListing: [],
    doctorDetails: [],
    createDoctor: [],
    updateDoctor: [],
    deleteDoctor: [],
    activationDoctor: [],
    doctorHistoryListing: [],
    exportDoctor: [],
    doctorOrders: [],
    doctorCommission: [],
    doctorCommissionBreakdown: [],
    error: [],
}

const Doctor = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_DOCTOR_LISTING_SUCCESS:
            return {
                ...state,
                doctorListing: action.payload
            }
        case GET_DOCTOR_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_DOCTOR_DETAILS_SUCCESS:
            return {
                ...state,
                doctorDetails: action.payload,
            };
        case GET_DOCTOR_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case ADD_DOCTOR_SUCCESS:
            return {
                ...state,
                createDoctor: action.payload,
            };
        case ADD_DOCTOR_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case UPDATE_DOCTOR_SUCCESS:
            return {
                ...state,
                updateDoctor: action.payload,
            };
        case UPDATE_DOCTOR_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case DELETE_DOCTOR_SUCCESS:
            return {
                ...state,
                deleteDoctor: action.payload,
            };
        case DELETE_DOCTOR_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case DOCTOR_ACTIVATION_SUCCESS:
            return {
                ...state,
                activationDoctor: action.payload,
            };
        case DOCTOR_ACTIVATION_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case GET_DOCTOR_HISTORY_LISTING_SUCCESS:
            return {
                ...state,
                doctorHistoryListing: action.payload,
            };
        case GET_DOCTOR_HISTORY_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case EXPORT_DOCTOR_LISTING_SUCCESS:
            return {
                ...state,
                exportDoctor: action.payload,
            };
        case EXPORT_DOCTOR_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case GET_DOCTOR_ORDERS_SUCCESS:
            return {
                ...state,
                doctorOrders: action.payload,
            };
        case GET_DOCTOR_ORDERS_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case GET_DOCTOR_COMMISSION_SUCCESS:
            return {
                ...state,
                doctorCommission: action.payload,
            };
        case GET_DOCTOR_COMMISSION_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case GET_DOCTOR_COMMISSION_BREAKDOWN_SUCCESS:
            return {
                ...state,
                doctorCommissionBreakdown: action.payload,
            };
        case GET_DOCTOR_COMMISSION_BREAKDOWN_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case RESET_DOCTOR_ACTION_STATE:
            return {
                ...state,
                createDoctor: [],
                updateDoctor: [],
                deleteDoctor: [],
                activationDoctor: [],
                doctorHistoryListing: [],
                exportDoctor: [],
                doctorOrders: [],
                doctorCommission: [],
                doctorCommissionBreakdown: [],
                error: [],
            }
        case RESET_DOCTOR_STATE:
            return {
                ...state,
                doctorListing: [],
                doctorDetails: [],
                createDoctor: [],
                updateDoctor: [],
                deleteDoctor: [],
                activationDoctor: [],
                doctorHistoryListing: [],
                exportDoctor: [],
                doctorOrders: [],
                doctorCommission: [],
                doctorCommissionBreakdown: [],
                error: [],
            }
        default:
            return state
    }
}

export default Doctor
